import type { ComponentProps } from "react";

import { CodeFrame } from "@/landing/system/code";

/** Fenced code in docs (and blog posts): the Grid CodeFrame. */
export function CodeBlock(props: ComponentProps<typeof CodeFrame>) {
  return <CodeFrame {...props} />;
}
